// extracted by mini-css-extract-plugin
module.exports = {"container":"FocusPageFocusFor_container__WMWdU","text":"FocusPageFocusFor_text__SLI9b","boxText":"FocusPageFocusFor_boxText__JG8iw","box":"FocusPageFocusFor_box__UIsjU"};